import * as React from 'react';
import InputContainer from 'src/modules/commons/inputs/input/Input.container';
import * as moment from 'moment';
import CountrySelectComponent from 'src/modules/commons/inputs/country-select/CountrySelect.component';
import PhysicalPersonData from 'src/value-objects/PhysicalPersonData';

export interface SpouseDataFormComponentProps {
  formData: PhysicalPersonData;
  handleChangeSpouse: (key: string) => (value: string | File | boolean | moment.Moment) => void;
}

class SpouseDataFormComponent extends React.PureComponent<SpouseDataFormComponentProps> {

  public render() {
    return (
      <section>
        <div
          className="accordion-toggle question-toggle collapsed pointer"
          data-toggle="collapse"
          data-parent="#faqAccordion"
          data-target="#question48"
        >
          <div className="icon-title">
            <img
              alt="Euro"
              className="icon"
              src="/img/us.png"
            />
            <h4 className="inline-block f-s-18">
              <strong>
                Datos cónyuge
              </strong>
              <span className="d-arrow-up" />
            </h4>
            <div className="gap-20" />
          </div>
        </div>
        <div
          id="question48"
          className="collapse"
        >
          <p>
            <strong>
              Cómo estas casado en régimen gananciales:
            </strong>
          </p>
          <p className="question-detail">
            Si estás casado en régimen de gananciales , de acuerdo al artículo 1.324 y siguientes del Código Civil,
            debemos dejar constancia que tu cónyuge es conocedor de esta inversión. Por lo que te pedimos que nos
            completes los datos que detallamos a continuación, a menos que tengáis capitulaciones que en ese caso solo
            necesitamos que nos respondas a este correo con el documento de las capitulaciones.
          </p>
          <div className="gap-20" />
          <div className="row">
            <div className="row">
              <div className="col-sm-6 col-md-4">
                <div className="md-input">
                  <InputContainer
                    label="Nombre"
                    type="text"
                    value={
                      this.props.formData.spouse ?
                        this.props.formData.spouse.name :
                        ''
                    }
                    required={true}
                    onChange={(value) => this.props.handleChangeSpouse('name')(value)}
                  />
                </div>
                <div className="gap-20" />
              </div>
              <div className="col-sm-6 col-md-4">
                <div className="md-input">
                  <InputContainer
                    label="Apellido/s"
                    type="text"
                    value={
                      this.props.formData.spouse ?
                        this.props.formData.spouse.surname :
                        ''
                    }
                    required={true}
                    onChange={(value) => this.props.handleChangeSpouse('surname')(value)}
                  />
                </div>
                <div className="gap-20" />
              </div>
              <div className="col-sm-6 col-md-4">
                <CountrySelectComponent
                  value={
                    this.props.formData.spouse ?
                      this.props.formData.spouse.nationality :
                      ''
                  }
                  required={true}
                  label={'Nacionalidad'}
                  onChange={(value) => this.props.handleChangeSpouse('nationality')(value)}
                />
                <div className="gap-20" />
              </div>

              <div className="col-sm-6 col-md-4">
                <div className="gap-20" />
                <div className="md-input">
                  <InputContainer
                    label="NIF o NIE"
                    type="text"
                    value={
                      this.props.formData.spouse ?
                        this.props.formData.spouse.idNumber :
                        ''
                    }
                    required={true}
                    onChange={(value) => this.props.handleChangeSpouse('idNumber')(value)}
                  />
                </div>
                <div className="gap-20" />
              </div>

              <div className="col-sm-6 col-md-4">
                <div className="gap-20" />
                <div className="md-input">
                  <InputContainer
                    label="E-mail"
                    type="text"
                    value={
                      this.props.formData.spouse ?
                        this.props.formData.spouse.email :
                        ''
                    }
                    required={true}
                    onChange={(value) => this.props.handleChangeSpouse('email')(value)}
                  />
                </div>
                <div className="gap-20" />
              </div>
            </div>
          </div>
          <div className="gap-20" />
          <p>
            <strong>
              Dirección habitual del cónyuge:
            </strong>
          </p>
          <p className="question-detail">
            La dirección debe ser la que aparece en el DNI
          </p>
          <div className="gap-20" />
          <div className="row">
            <div className="col-sm-6 col-md-4">
              <div className="md-input">
                <InputContainer
                  label="Dirección"
                  type="text"
                  value={
                    this.props.formData.spouse ?
                      this.props.formData.spouse.address :
                      ''
                  }
                  required={true}
                  onChange={(value) => this.props.handleChangeSpouse('address')(value)}
                />
              </div>
              <div className="gap-20" />
            </div>
            <div className="col-sm-6 col-md-4">
              <div className="md-input">
                <InputContainer
                  label="Piso, escalera, puerta"
                  type="text"
                  value={
                    this.props.formData.spouse ?
                      this.props.formData.spouse.houseNumber :
                      ''
                  }
                  required={false}
                  onChange={(value) => this.props.handleChangeSpouse('houseNumber')(value)}
                />
              </div>
              <div className="gap-20" />
            </div>
            <div className="col-sm-6 col-md-4">
              <div className="md-input">
                <InputContainer
                  label="Código postal"
                  type="text"
                  value={
                    this.props.formData.spouse ?
                      this.props.formData.spouse.zipCode :
                      ''
                  }
                  required={true}
                  onChange={(value) => this.props.handleChangeSpouse('zipCode')(value)}
                />
              </div>
              <div className="gap-20" />
            </div>

            <div className="col-sm-6 col-md-4">
              <div className="md-input">
                <InputContainer
                  label="Ciudad"
                  type="text"
                  value={
                    this.props.formData.spouse ?
                      this.props.formData.spouse.city :
                      ''
                  }
                  required={true}
                  onChange={(value) => this.props.handleChangeSpouse('city')(value)}
                />
              </div>
              <div className="gap-20" />
            </div>
            <div className="col-sm-6 col-md-4">
              <div className="md-input">
                <InputContainer
                  label="Provincia"
                  type="text"
                  value={
                    this.props.formData.spouse ?
                      this.props.formData.spouse.province :
                      ''
                  }
                  required={true}
                  onChange={(value) => this.props.handleChangeSpouse('province')(value)}
                />
              </div>
              <div className="gap-20" />
            </div>
            <div className="col-sm-6 col-md-4">
              <CountrySelectComponent
                value={this.props.formData.spouse ? this.props.formData.spouse.country : undefined}
                required={true}
                onChange={(value) => this.props.handleChangeSpouse('country')(value)}
              />
              <div className="gap-20" />
            </div>
          </div>
        </div>
      </section>
    );
  }
}

export default SpouseDataFormComponent;


// WEBPACK FOOTER //
// ./src/modules/my-account/physical-person-update/forms/SpouseDataForm.component.tsx